export default __webpack_public_path__ + "static/media/slider2.31477687.jpg";